<div class="container">
  <div class="alert">
    <div class="text">
      Ваша заявка на проверку оплаты лицензии от {{ date }} успешно отправлена и
      ожидает рассмотрения
    </div>
  </div>
</div>
